module.exports = __webpack_public_path__ + "media/images/icons/project-9e2922454322c8fd0714079dafc8808a.svg";